import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedButtonComponent } from '@plugins/client/button/shared-button';
import { ConfirmDialogModule } from '@plugins/client/confirm-dialog/confirm-dialog.module';
import { LetDirectiveModule } from '@plugins/client/directives/let-directive.module';
import { FeatureCheckComponent } from '@plugins/client/feature-check';
import { FormModule } from '@plugins/client/forms/form';
import { SelectModule } from '@plugins/client/forms/select/select.module';
import { CancelIconComponent } from '@plugins/client/icons/cancel-icon';
import { TooltipDirective } from '@plugins/client/tooltip/tooltip.directive';
import { TranslatePipe } from '@plugins/client/translate/pipes';

import { MultiLanguageActionComponent } from '../private/components/atoms/action-button/action-button.component';
import { MultilanguageAddComponent } from '../private/components/atoms/add-language/add-language.component';
import { MultilanguageLabelWrapperComponent } from '../private/components/atoms/label-wrapper/label-wrapper.component';
import { MultilanguageIconsComponent } from '../private/components/atoms/language-icons/language-icons.component';
import { MultilanguageRemoveComponent } from '../private/components/atoms/remove-language/remove-language.component';
import { MultilanguageEntryComponent } from '../private/components/molecules/language-entry/language-entry.component';
import { MultilanguageLabelComponent } from '../private/components/molecules/language-label/language-label.component';
import { MultilanguageAddDialogComponent } from '../private/components/organisms/multilanguage-add-dialog/multilanguage-add-dialog.component';
import { MultilanguageBarComponent } from '../private/components/organisms/multilanguage-bar/multilanguage-bar.component';
import { MultilanguageDirective } from '../private/directives/multilanguage.directive';

import { MultilanguagePipe } from './multilanguage.pipe';
import { MultilanguageTranslationModule } from './translation-loader';

@NgModule({
  imports: [
    CancelIconComponent,
    CommonModule,
    ConfirmDialogModule,
    FormModule,
    FeatureCheckComponent,
    LetDirectiveModule,
    MultilanguageTranslationModule,
    TranslatePipe,
    MultiLanguageActionComponent,
    MultilanguageAddComponent,
    MultilanguageEntryComponent,
    MultilanguageIconsComponent,
    MultilanguageLabelComponent,
    MultilanguageLabelWrapperComponent,
    MultilanguagePipe,
    MultilanguageRemoveComponent,
    ReactiveFormsModule,
    SelectModule,
    SharedButtonComponent,
    TooltipDirective,
  ],
  declarations: [
    MultilanguageAddDialogComponent,
    MultilanguageBarComponent,
    MultilanguageDirective,
  ],
  exports: [
    MultilanguageBarComponent,
    MultilanguageDirective,
    MultilanguagePipe,
  ],
})
export class MultilanguageModule {}
